import type { FormIdentity } from '../../types';
import { SectionCard } from './SectionCard';

/**
 * Collapsible "Form Identity" key/value section. Mirrors the original
 * standalone app's Form Identity panel — the basics a process owner needs
 * to confirm they're looking at the right form. Deliberately omits sys_id
 * and table name; this is a design doc, not a tech reference.
 */
export function FormIdentitySection({ identity }: { identity: FormIdentity }) {
  const rows: { label: string; value: string | null | undefined }[] = [
    { label: 'Name', value: identity.name },
    { label: 'Stream / Team', value: identity.stream },
    { label: 'Catalog', value: identity.catalog },
    { label: 'Category', value: identity.category },
    {
      label: 'Description',
      value: identity.description || identity.short_description,
    },
    { label: 'Assignment group', value: identity.assignment_group_default },
    { label: 'Available for', value: identity.available_for },
    { label: 'Priority by default', value: identity.priority },
  ];
  const visible = rows.filter((r) => Boolean(r.value));
  return (
    <SectionCard title="Form Identity" defaultOpen>
      <dl className="divide-y divide-slate-100">
        {visible.map((r) => (
          <div
            key={r.label}
            className="grid grid-cols-1 sm:grid-cols-[200px_1fr] gap-1 sm:gap-6 py-2.5 first:pt-0 last:pb-0"
          >
            <dt className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">
              {r.label}
            </dt>
            <dd className="text-sm text-slate-800 break-words">{r.value}</dd>
          </div>
        ))}
      </dl>
    </SectionCard>
  );
}
